import ct from 'countries-and-timezones';
import { codes as callingCodes } from 'country-calling-code';

// `domain.country` holds a country *name*, and the vocabulary is `country-calling-code`'s:
// that is the list the country selects offer and the list the API reads back.
// `countries-and-timezones` spells 15 of those countries differently — "United States" vs
// "United States of America", "Turkey" vs "Türkiye", "Czech Republic" vs "Czechia",
// "Macedonia" vs "North Macedonia", … — so matching the two libraries by name silently
// fails for exactly those countries. Resolve through the ISO 3166-1 alpha-2 code instead;
// both libraries agree on it. Mirrors helpers/country-timezones-helper.js in magellan-api.
const isoCodeByCountryName = new Map();

for (const entry of callingCodes) {
  isoCodeByCountryName.set(entry.country, entry.isoCode2);
}

// Also accept the `countries-and-timezones` spelling, so a country stored under that
// vocabulary by some other path still resolves. Calling-code names win on conflict.
for (const country of Object.values(ct.getAllCountries())) {
  if (!isoCodeByCountryName.has(country.name)) {
    isoCodeByCountryName.set(country.name, country.id);
  }
}

export const DEFAULT_TIMEZONE = 'Etc/UTC';

export const getCountryIsoCode = (countryName) => isoCodeByCountryName.get(countryName) || null;

// Kosovo (XK) and Netherlands Antilles (AN) are offered by `country-calling-code` but have
// no `countries-and-timezones` entry, so an empty list is a normal outcome, not a bug.
export const getCountryTimezones = (countryName) => {
  const isoCode = getCountryIsoCode(countryName);

  return (isoCode && ct.getCountry(isoCode)?.timezones) || [];
};
